import {
  getAllSuppliersGroups,
  updateSuppliersGroup,
  deleteSuppliersGroup,
  newSuppliersGroup,
} from '../supplier-group-services';

export default {
  /**
   * Get All statuses
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllSuppliersGroups({ commit }) {
    const response = await getAllSuppliersGroups();
    commit('setProperty', { property: 'suppliers_groups', payload: response });
  },

  /**
   *
   * @param commit
   * @param groupId
   * @returns {Promise<void>}
   */
  async deleteSuppliersGroup({ commit }, { groupId }) {
    await deleteSuppliersGroup(groupId);
    commit('delProperty', { property: groupId });
  },

  /**
   *
   * @param context
   * @param groupId
   * @param suppliersGroup
   * @returns {Promise<void>}
   */
  async updateSuppliersGroup(context, { groupId, suppliersGroup }) {
    await updateSuppliersGroup(groupId, suppliersGroup);
  },

  /**
   *
   * @param context
   * @param suppliersGroup
   * @returns {Promise<void>}
   */
  async newSuppliersGroup({ commit }, { suppliersGroup }) {
    const response = await newSuppliersGroup(suppliersGroup);
    commit('setNewSuppliersGroup', { payload: response });
  },
};
